import 'jquery.growl';
import 'jquery-validate';
import 'select2';
import 'bootstrap-tagsinput';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/autocomplete';
import './bootstrap';
import './pixel-admin';
import './jquery.PrintArea';
import './jquery-ui-extras';
import './jquery-ui-timepicker-addon';
import './demo';
import './jquery.maskMoney.min';
import 'bootbox';
import {sisPrintRelatorio} from './js_relatorio';
import PixelPadrao from './PixelPadrao';
import Estabelecimento from './estabelecimento';

// Expose Report functions to window
window.sisPrintRelatorio = sisPrintRelatorio;

// Expose PixelPadrao functions to window
PixelPadrao.forEach(f => window[f.name] = f);

export {
  Estabelecimento
}



// WEBPACK FOOTER //
// ./resources/js/main.js